import React, {Component} from 'react';
import PropTypes from "prop-types";
import ScrollAnimation from 'react-animate-on-scroll';

class About extends Component {
  render() {
    //About loop END
    return (
      <React.Fragment>
        <section id="about" className="about-us ptb-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center">
                <ScrollAnimation animateIn="fadeInUp">
                  <div className="section-title">
                    <h2>{this.props.sectionTitle}</h2>
                    <p>{this.props.sectionDescription1}</p>
                    <p>{this.props.sectionDescription2}</p>
                    <p>{this.props.sectionDescription3}</p>
                    <p>{this.props.sectionDescription4}</p>
                    <p>{this.props.sectionDescription5}</p>
                    <p>{this.props.sectionDescription6}</p>
                    <span
                      className="section-title-bg">{this.props.SectionbgTitle}</span>
                  </div>
                </ScrollAnimation>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

//Props Types
About.propTypes = {
  SectionbgTitle: PropTypes.string,
  sectionTitle: PropTypes.string,
  sectionDescription: PropTypes.string,
  aboutsData: PropTypes.array
};

//Default Props
About.defaultProps = {
  SectionbgTitle: "Despre Noi",
  sectionTitle: "Despre Noi",
  brand: "Casa Maria",
  sectionDescription1:
    "Asociatia Casa Maria a luat fiinta in anul 2013 din dorinta de a ajuta cea mai vulnerabila categorie sociala, persoanele varstnice.",
  sectionDescription2:
    "Casa Maria este centru rezidential care ofera si asigura, in regim institutionalizat, conditii de gazduire si hrana, ingrijire personala si medicala, pe perioada nedeterminata, in functie de nevoile individuale ale persoanelor varstnice si de capacitatea proprie (35 locuri).",
  sectionDescription3:
    "Serviciile sociale sunt oferite in baza acreditarii si licentei de functionare.",
  sectionDescription4:
    "Centrul rezidențial beneficiază de toate standardele, și răspunde întru totul de nevoile persoanelor în vârstă, pentru a locui în deplină siguranță.",
  sectionDescription5:
    "Persoanele varstnice care vor locui în Centrul rezidențial pentru seniori Casa Maria, se vor putea bucura de liniște și confort, într-un cadru retras, ferit de zgomotul și poluarea orașului.",
  sectionDescription6:
    "Panorama splendidă este completată de confortul celor 13 camere spațioase, dotate corespunzator , prevăzute cu grupri sanitare proprii, sala de mese, camera de zi si sala de activitati.",
};

export default About;
